import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
  name: 'tamperDtFormatted',
  standalone: true,
})
export class TamperDtFormattedPipe implements PipeTransform {
  transform(tamperDt: string | Date | null | undefined): string | null {
    if (!tamperDt) {
      return null;
    }

    const parsedDate = new Date(tamperDt);

    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return format(parsedDate, 'dd.MM.yyyy HH:mm:ss');
  }
}
